import React from 'react';
import pluralize from 'pluralize';
import { pick } from 'lodash';
import { DollarAmount } from 'common/display/Money';
import formatShortDate from 'common/utils/Dates/formatShortDate';
import {
  AUTHORIZATION_STATUSES,
  AUTHORIZATION_STATUSES_TO_ICON,
  AUTHORIZATION_STATUSES_TO_COLOR,
} from 'common/Status/authorizationConstants';

export const formatAmount = (authorization) => {
  const cents = authorization.approved_cents || authorization.requested_cents;
  if (cents) {
    return <DollarAmount value={cents} convertCents />;
  }

  const unitAmount = authorization.approved_unit_amount || authorization.requested_unit_amount;
  if (unitAmount) {
    const unit = authorization.fee_schedule_program?.unit || 'unit';
    const pluralizedUnit = pluralize(unit, unitAmount);
    return `${unitAmount} ${pluralizedUnit}`;
  }

  return 'N/A';
};

export const formatDates = (authorization) => {
  const startsAt = authorization.approved_starts_at || authorization.requested_starts_at;
  const endsAt = authorization.approved_ends_at || authorization.requested_ends_at;

  if (!startsAt && !endsAt) {
    return 'N/A';
  }

  if (startsAt && endsAt) {
    const formattedStartsAt = formatShortDate(startsAt);
    const formattedEndsAt = formatShortDate(endsAt);

    if (formattedStartsAt === formattedEndsAt) {
      return formattedStartsAt;
    }

    return `${formattedStartsAt} - ${formattedEndsAt}`;
  }

  return formatShortDate(startsAt);
};

export const authorizationHistoryIcon = pick(
  AUTHORIZATION_STATUSES_TO_ICON,
  [
    AUTHORIZATION_STATUSES.accepted,
    AUTHORIZATION_STATUSES.rejected,
    AUTHORIZATION_STATUSES.void,
  ],
);

export const authorizationHistoryIconColor = {
  ...AUTHORIZATION_STATUSES_TO_COLOR,
  [AUTHORIZATION_STATUSES.void]: 'var(--color-text-blue)',
};
